import * as core from '../../../../../../../core'

import { query } from './outcome-overview.query'

export const RESOURCE = {
  payload: {
    alias: 'summit.outcome-overview',
    description:
      'Displays information about the currently focused outcome, if there is one',
    name: 'Summit - Outcome Overview',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
